import { Component, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { LoincObjectGroup, PanelsAndFormsService } from '../../../../../shared/services/loinc.service';
import { ActivatedRoute, Params } from '@angular/router';
import { API_BASE_LOINC } from '../../../../../shared/common';


@Component({
  selector: 'app-loinc-panels-forms',
  templateUrl: './loinc-panels-forms.component.html',
  styleUrls: ['./loinc-panels-forms.component.scss']
})
export class LoincPanelsFormsComponent implements OnInit {
  private destroy$ = new Subject<void>();
  singleResult: LoincObjectGroup = {};
  id: string = '';
  key: string = 'id';
  language: string = localStorage.getItem('lang') ?? 'vi';

  constructor(
    public panelsAndFormsService: PanelsAndFormsService,
    private route: ActivatedRoute
  ) {
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params: Params) => {
      this.id = params['id'];
      if (this.id) {
        this.getDetail();
      }
    })
  }

  ngOnInit(): void {}

  getDetail() {
    this.panelsAndFormsService.retrieve(this.id).subscribe((data) => {
      this.singleResult = data;
    })
  }

  isDetailView(): boolean {
    return Object.keys(this.singleResult).length > 0;
  }

  getFeedbackURL() {
    return `${API_BASE_LOINC}/${this.language}/admin/panels_and_forms/panelsandforms/${this.id}/change/`
  }
}
